import Storage from "../utils/Storage";

export const grantAccess = (token, user, redirectTo) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const redirect_uri = params?.get("redirect_uri");

  Storage.setToken(token);

  if (redirect_uri && validateURL(redirect_uri)) {
    window.location = redirect_uri;
  } else if (redirectTo && validateURL(redirectTo)) {
    window.location = redirectTo;
  } else if (user.is_superadmin) {
    window.location = "/admin";
  } else {
    window.location = "/profile";
  }
};


function validateURL(sUrl) {
    try {
      const url = new URL(sUrl, window.location.origin);
      const urlHostname = url.hostname.trim();
      return urlHostname === '' || urlHostname.toUpperCase() === window.location.hostname.trim().toUpperCase();
    } catch {
      return false;
    }
  }
  

export const logout = () => {
    Storage.clear()
    //clear session storage
    Storage.clear(true)
    window.location = "/"
}
